import React, { useState, useEffect, useRef } from 'react';
import Api from '../Services/ApiCall';
import { Link } from "react-router-dom";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-enterprise/styles/ag-theme-alpine.css';
import 'ag-grid-enterprise';
import { BeatLoader } from "react-spinners";
import Base from '../Base';

export default function OrderReport() {
    const [rowData, setRowData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [search, setSearch] = useState("All");
    const [quickFilterText, setQuickFilterText] = useState("");
    const hasFetchedData = useRef(false);
    const getFormattedDate = (date) => date.toISOString().split('T')[0];
    const today = new Date();
    const sevenDaysAgo = new Date();
    sevenDaysAgo.setDate(today.getDate() - 7);
    const [fromDate, setFromDate] = useState(getFormattedDate(sevenDaysAgo));
    const [toDate, setToDate] = useState(getFormattedDate(today));

    useEffect(() => {
        fetchDataAndSetState();
    }, [search]); 

    const fetchDataAndSetState = async () => {
        setIsLoading(true);
        try {
            const Param = { status: search  ,FromDate: fromDate,
                ToDate: toDate };
            const url = "/Report/OrderReport";
            let _response1 = await Api.BindGrid(Param, url);

            setRowData(_response1);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setIsLoading(false);
        }
    };
    const handleSearch = () => {
        fetchDataAndSetState();
    };
    const columnDefs = [
        { headerName: 'Order ID', field: 'Orderid', filter: true },
        { headerName: 'Date', field: 'Ordercode', filter: true },
        { headerName: 'Customer Id', field: 'Usercode', filter: true },
        { headerName: 'User Type', field: 'Usertype', filter: true },
        { headerName: 'Status', field: 'Status', filter: true },
        { headerName: 'CreatedBy', field: 'CreatedBy', filter: true },
    ];

    return (
        <div>
            <Base OrderReport={true} />
            <div id="main" className="main">
                <div className="pagetitle">
                    <nav>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">Report</li>
                            <li className="breadcrumb-item active">Sales Report</li>
                        </ol>
                    </nav>
                </div>

                <input
                    type="text"
                    placeholder="Search..."
                    onChange={(e) => setQuickFilterText(e.target.value)}
                    style={{ marginBottom: '10px' }}
                />

                
                <div className="row mb-3">
                    <div className="col-md-3 d-flex align-items-end">
                        <select
                            id="inputState"
                            className="form-select"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                        >
                            <option value="All">All</option>
                            <option value="Created">Created</option>
                            <option value="Success">Success</option>
                        </select>
                    </div>
                    <div className="col-md-3">
                        <label>From Date</label>
                        <input
                            type="date"
                            className="form-control"
                            value={fromDate}
                            onChange={(e) => setFromDate(e.target.value)}
                            max={getFormattedDate(today)}
                        />
                    </div>
                    <div className="col-md-3">
                        <label>To Date</label>
                        <input
                            type="date"
                            className="form-control"
                            value={toDate}
                            onChange={(e) => setToDate(e.target.value)}
                            max={getFormattedDate(today)}
                        />
                    </div>
                    <div className="col-md-3 d-flex align-items-end">
                        <button className="btn btn-primary w-100" onClick={handleSearch}>
                            Search
                        </button>
                    </div>
                </div>

                {isLoading ? (
                    <div className="d-flex justify-content-center my-5 pt-5">
                        <BeatLoader />
                    </div>
                ) : (
                    <div className="ag-theme-alpine" style={{ height: 400, width: '100%' }}>
                        <AgGridReact
                            rowData={rowData}
                            columnDefs={columnDefs}
                            pagination={true}
                            paginationPageSize={10}
                            domLayout='autoHeight'
                            floatingFilter={true}
                            enableBrowserTooltips={true}
                            quickFilterText={quickFilterText} // Pass quick filter
                        />
                    </div>
                )}
            </div>
        </div>
    );
}
